import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';
import './Careers.css';

interface Job {
  title: string;
  desc: string;
  dept: string;
  location: string;
  type: string;
}

// const jobs: Job[] = [
//   {
//     title: 'Senior Agro Export Manager',
//     desc: 'Lead international export operations and manage key buyer relationships.',
//     dept: 'Agro Export',
//     location: 'Chennai, India',
//     type: 'Full-time',
//   },
//   {
//     title: 'Full Stack Developer',
//     desc: 'Build and maintain enterprise-grade web applications using React and Node.js.',
//     dept: 'IT Solutions',
//     location: 'Remote',
//     type: 'Full-time',
//   },
//   {
//     title: 'Civil Project Engineer',
//     desc: 'Manage on-site construction projects, quality control, and contractor coordination.',
//     dept: 'Construction',
//     location: 'Coimbatore, India',
//     type: 'Full-time',
//   },
//   {
//     title: 'Business Development Executive',
//     desc: "Identify and pursue new business opportunities across Ajera's industry verticals.",
//     dept: 'Corporate',
//     location: 'Chennai, India',
//     type: 'Full-time',
//   },
//   {
//     title: 'UI/UX Designer',
//     desc: "Design intuitive and beautiful interfaces for Ajera Infotech's product suite.",
//     dept: 'IT Solutions',
//     location: 'Remote',
//     type: 'Contract',
//   },
// ];
const jobs: Job[] = [
  {
    title: 'Full Stack Developer Trainee',
    desc: 'Build end-to-end web applications on a modern stack in an agile environment.',
    dept: 'Engineering',
    location: 'Remote',
    type: 'Trainee',
  },
  {
    title: 'AI / ML Engineer Trainee',
    desc: 'Design and deploy intelligent models — NLP, computer vision, prediction systems.',
    dept: 'Data & AI',
    location: 'Remote',
    type: 'Trainee',
  },
  {
    title: 'Application Developer Trainee',
    desc: 'Build high-performance cross-platform apps for enterprise clients.',
    dept: 'Engineering',
    location: 'Remote',
    type: 'Trainee',
  },
  {
    title: 'Trainer',
    desc: 'Conduct training sessions, mentor learners, provide project guidance, prepare training materials, and help students build practical software development skills.',
    dept: 'Training',
    location: 'Remote',
    type: 'Full-time',
  },
  {
    title: 'Frontend Dev Intern',
    desc: 'Work alongside seniors building real client-facing web apps.',
    dept: 'Engineering',
    location: 'Remote',
    type: 'Internship',
  },
  {
    title: 'Backend Dev Intern',
    desc: 'Build APIs, server logic and database integrations in production.',
    dept: 'Engineering',
    location: 'Remote',
    type: 'Internship',
  },
  {
    title: 'AI / ML Intern',
    desc: 'Assist in developing ML models and data pipelines for real projects.',
    dept: 'Data & AI',
    location: 'Remote',
    type: 'Internship',
  },
  {
    title: 'UI/UX Design Intern',
    desc: 'Design interfaces and conduct UX research for our client portfolio.',
    dept: 'Design',
    location: 'Remote',
    type: 'Internship',
  },
  {
    title: 'Digital Marketing Intern',
    desc: 'Drive growth through content creation, SEO and social campaigns.',
    dept: 'Marketing',
    location: 'Remote',
    type: 'Internship',
  },
  {
    title: 'Mobile App Dev Intern',
    desc: 'Develop features and fix bugs under expert mentorship.',
    dept: 'Engineering',
    location: 'Remote',
    type: 'Internship',
  },
];
interface FormState {
  name: string;
  email: string;
  phone: string;
  skills: string;
  experience: string;
  message: string;
  resume: File | null;
}

const initialForm: FormState = {
  name: '',
  email: '',
  phone: '',
  skills: '',
  experience: '',
  message: '',
  resume: null,
};

const Careers: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState<FormState>(initialForm);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const openModal = (job: Job) => {
    setSelectedJob(job);
    setForm(initialForm);
    setSuccessMsg('');
    setErrorMsg('');
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedJob(null);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null;
    setForm((prev) => ({ ...prev, resume: file }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.resume) {
      setErrorMsg('Please upload your resume.');
      return;
    }

    setLoading(true);
    setSuccessMsg('');
    setErrorMsg('');

    const formData = new FormData();
    formData.append('name', form.name);
    formData.append('email', form.email);
    formData.append('phone', form.phone);
    formData.append('job_title', selectedJob!.title);
    formData.append('skills', form.skills);
    formData.append('experience', form.experience);
    formData.append('message', form.message);
    formData.append('resume', form.resume);

    try {
      // const res = await fetch(`http://localhost:4000/careers/apply`, {
      const res = await fetch(`https://ajeragroup-backend.onrender.com/careers/apply`, {
        method: 'POST',
        body: formData,
      });
      const result = await res.json();

      if (result.success) {
        setSuccessMsg('✅ Application submitted! We will get back to you soon.');
        setForm(initialForm);
        // Auto-close modal after 2.5s
        setTimeout(() => closeModal(), 2500);
      } else {
        setErrorMsg('❌ ' + (result.message || 'Something went wrong.'));
      }
    } catch (err) {
      setErrorMsg('❌ Server error. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHeader
        breadcrumb="Careers"
        title="Join Ajera Group"
        subtitle="Build your career with a fast-growing multi-industry enterprise."
      />

      <div className="careers-list">
        {jobs.map((job) => (
          <div className="job-card" key={job.title}>
            <div className="job-info">
              <h3>{job.title}</h3>
              <p>{job.desc}</p>
              <div className="job-tags">
                <span className="job-tag dept">{job.dept}</span>
                <span className="job-tag loc">{job.location}</span>
                <span className="job-tag type">{job.type}</span>
              </div>
            </div>
            <button className="apply-btn" onClick={() => openModal(job)}>
              Apply Now
            </button>
          </div>
        ))}
      </div>

      {/* <div className="global-presence">
  🌍 Global Presence: India • Canada • Japan
</div> */}

      {showModal && selectedJob && (
        <div
          className="apply-modal"
          onClick={(e) => {
            if ((e.target as HTMLElement).classList.contains('apply-modal'))
              closeModal();
          }}
        >
          <div className="apply-box">
            <div className="apply-header">
              <h2>Apply for {selectedJob.title}</h2>
              <button className="close-btn" onClick={closeModal} aria-label="Close">
                ✕
              </button>
            </div>

            <form className="apply-form" onSubmit={handleSubmit}>
              <input
                name="name"
                placeholder="Full Name"
                required
                value={form.name}
                onChange={handleChange}
              />
              <input
                name="email"
                type="email"
                placeholder="Email Address"
                required
                value={form.email}
                onChange={handleChange}
              />
              <input
                name="phone"
                type="tel"
                placeholder="Phone Number"
                required
                value={form.phone}
                onChange={handleChange}
              />
              <input
                name="skills"
                placeholder="Your Skills (e.g. React, Node.js)"
                required
                value={form.skills}
                onChange={handleChange}
              />
              <input
                name="experience"
                type="number"
                min="0"
                max="50"
                placeholder="Years of Experience"
                required
                value={form.experience}
                onChange={handleChange}
              />
              <textarea
                name="message"
                placeholder="Why should we hire you?"
                value={form.message}
                onChange={handleChange}
              />
              <input
                name="resume"
                type="file"
                accept=".pdf,.doc,.docx"
                required
                onChange={handleFileChange}
              />

              {successMsg && <p className="form-success">{successMsg}</p>}
              {errorMsg && <p className="form-error">{errorMsg}</p>}

              <button type="submit" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit Application'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Careers;